import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { FieldTypeFactoryService } from '@services/factories/field-type/field-type-factory.service'
import { FieldEntities } from '@models/ui'
import { keyBy, reduce, values } from 'lodash-es'

@Component({
    selector: 'app-field-section-content',
    imports: [TbIconComponent],
    templateUrl: './field-section-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldSectionContentComponent {
    private readonly fieldTypeFactoryService = inject(FieldTypeFactoryService)

    readonly fields = input.required<FieldEntities>()
    readonly inactiveFields = input<string[]>([])

    protected readonly fieldsArray = computed(() => values(this.fields()))
    protected readonly inactiveFieldsObject = computed(() => keyBy(this.inactiveFields()))

    fieldsIcons = computed(() => {
        return reduce(
            this.fields(),
            (acc, field) => {
                acc[field.guid] = this.fieldTypeFactoryService.getIconByFieldType(
                    field.field_type_code,
                )

                return acc
            },
            {} as Record<string, string>,
        )
    })
}
